import { useConfig } from '../../../providers/envConfig'
import useFetch from '../../helpers/useFetch'

export type AuthPSNResponse = {
  // The Verifiable Parental Consent (VPC) service JSON Web Token
  jwt: string

  // The PlayStation Network (PSN) online ID of the user
  online_id: string
}

/**
 * usePostPSN is a custom hook that requests a Verifiable Parental Consent (VPC)
 * service JSON Web Token (JWT) for the provided PlayStation Network (PSN)
 * authorization code and redirect URI.
 * @param authCode - The authorization code received from the PSN OAuth flow.
 * @return An object containing the JWT, online ID, loading state, error state,
 */
export const usePostPSN = (authCode: string | null) => {
  const envConfig = useConfig()

  const url = `${envConfig.vpcUrl}/auth/psn`
  const fields: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Bnet-Key': envConfig.bnetKey,
    },
    body: JSON.stringify({
      auth_code: authCode,
      redirect_uri: envConfig.playStation.callbackUri,
    }),
  }

  const { data, loading, error, callFetch } = useFetch<AuthPSNResponse>(url, fields)

  return { data, loading, error, callFetch }
}

export default usePostPSN
